import Insurance, {IInsurance} from "@/model/Insurance/Insurance"
import hasIncluded, {IHasIncluded} from "@/model/mixins/hasIncluded"
import hasSelected, {IHasSelected} from "@/model/mixins/hasSelected"
import hasTotalPrice, {IHasTotalPrice} from "@/model/mixins/Price/hasTotalPrice"

class GlobalInsuranceBase extends Insurance {
    constructor(
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
    }

}

export interface IGlobalInsurance extends GlobalInsuranceBase, IInsurance, IHasIncluded, IHasSelected, IHasTotalPrice {}

// apply mixins
const GlobalInsurance: Constructor<IGlobalInsurance> = hasTotalPrice(hasSelected(hasIncluded(GlobalInsuranceBase)))

export default GlobalInsurance